/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton } from '@neo4j-ndl/react';
import { useMemo, useRef, useState } from 'react';

const Component = () => {
  const [secondsLeft, setSecondsLeft] = useState<number>(0);
  const [isRunning, setIsRunning] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const buttonProps = useMemo(() => {
    return !isRunning
      ? {
          children: 'Run',
          onClick: () => {
            setSecondsLeft(5);
            intervalRef.current = setInterval(() => {
              setSecondsLeft((prev) => prev - 1);
            }, 1000);
            // Start the mocked running process. This would be your running function.
            timeoutRef.current = setTimeout(() => {
              setIsRunning(false);
              timeoutRef.current = null;
              if (intervalRef.current) {
                clearInterval(intervalRef.current);
              }
            }, 5000);
            setIsRunning(true);
          },
        }
      : {
          children: 'Cancel',
          onClick: () => {
            if (intervalRef.current) {
              clearInterval(intervalRef.current);
            }
            intervalRef.current = null;
            // Cancel the mocked running process. This would be your cancel the running function.
            if (timeoutRef.current) {
              clearTimeout(timeoutRef.current);
              timeoutRef.current = null;
            }
            setIsRunning(false);
          },
        };
  }, [isRunning]);

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
      }}
    >
      <div>Click to start the mocked running process</div>
      <FilledButton style={{ width: '100px' }} {...buttonProps} />
      <div style={{ marginTop: '10px', position: 'relative' }}>
        <span>Status: </span>
        <span
          style={{
            color: isRunning ? 'green' : 'red',
            fontWeight: 'bold',
          }}
        >
          {isRunning ? `Running (${secondsLeft} seconds left)` : 'Not running'}
        </span>
      </div>
    </div>
  );
};

export default Component;
